import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddVehicleUtilities = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [vehicle, setVehicle] = useState([]);
  const [Company, setCompany] = useState([]);
  const [Staff, setStaff] = useState([]);
  // console.log(Material)
  const [rowAddData, setRowAddData] = useState({
    vehicle_id: "",
    utility_name: "",
    utility_type: "",
    assembling_date: "",
    service_count: "",
    utility_usage: "",
    service_need: "",
    vehicle_part_breakdown: "",
    expense_of_breakdown: "",
  });
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedStafflId, setSelectedStaffId] = useState("");
  function resetFileds() {
    setRowAddData({
      vehicle_id: "",
      utility_name: "",
      utility_type: "",
      assembling_date: "",
      service_count: "",
      utility_usage: "",
      service_need: "",
      vehicle_part_breakdown: "",
      expense_of_breakdown: "",
    });
    setSelectedStaffId("");
    setSelectedVehicleId("");
    setSelectedCompanyId("");
  }

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setSelectedStaffId(e.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      utility_type,
      utility_name,
      assembling_date,
      service_count,
      utility_usage,
      service_need,
      vehicle_part_breakdown,
      expense_of_breakdown,
    } = rowAddData;

    let BASE_URL =
      SERVER_URL +
      `/api/vehicle-utilities/vehicle-utilities-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        vehicle_id: selectedVehicleId,
        utility_type,
        utility_name,
        assembling_date: moment(assembling_date).format("YYY-MM-DD"),
        service_count,
        utility_usage,
        service_need,
        vehicle_part_breakdown,
        expense_of_breakdown,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        resetFileds();
        getData();
        // formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getStaff = async (e) => {
    // console.log(e.target.value)
    setSelectedCompanyId(e.target.value);
    const companyID = e.target.value;
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${companyID}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setStaff(result.data);
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Vehicle Utilities
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getStaff(e)}
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {Company &&
                                Company?.length > 0 &&
                                Company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div> */}
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="staff_id">Driver Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleStaffChange}
                              value={selectedStafflId}
                              id="staff_id"
                              required
                            >
                              <option value="">Select Driver Name</option>
                              {Staff &&
                                Staff?.length > 0 &&
                                Staff?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option
                                        value={item.id}
                                      >{`${item.staff_name}`}</option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="material_name">
                              Vehicle Number
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleVehicleChange}
                              value={selectedVehicleId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.vehicle_number}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="utility_name">Utility Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="utility_name"
                              id="utility_name"
                              placeholder="Utility Name"
                              onChange={handleChange}
                              value={rowAddData.utility_name}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="utility_type">Utility Type</label>
                            <input
                              type="text"
                              className="form-control"
                              name="utility_type"
                              id="utility_type"
                              placeholder="utility_type"
                              onChange={handleChange}
                              value={rowAddData.utility_type}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="assembling_date">
                              Assembling Date
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="assembling_date"
                              id="assembling_date"
                              placeholder="Assembling Date"
                              onChange={handleChange}
                              value={rowAddData.assembling_date}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="warrenty_guarantee">
                              Service Count
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="service_count"
                              id="service_count"
                              placeholder="Service Count"
                              onChange={handleChange}
                              value={rowAddData.service_count}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="warrenty_guarantee">
                              Utility Usage
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="utility_usage"
                              id="utility_usage"
                              placeholder="Utility Usage"
                              onChange={handleChange}
                              value={rowAddData.utility_usage}
                              // required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="service_need">Service Need</label>
                            <input
                              type="text"
                              className="form-control"
                              name="service_need"
                              id="service_need"
                              placeholder="Service Need"
                              onChange={handleChange}
                              value={rowAddData.service_need}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="vehicle_part_breakdown">
                              Vehicle Part Breakdown
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="vehicle_part_breakdown"
                              id="vehicle_part_breakdown"
                              placeholder="Vehicle Part Breakdown"
                              onChange={handleChange}
                              value={rowAddData.vehicle_part_breakdown}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="expense_of_breakdown">
                              Expense Of Breakdown
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="expense_of_breakdown"
                              id="expense_of_breakdown"
                              placeholder="Expense Of Breakdown"
                              onChange={handleChange}
                              value={rowAddData.expense_of_breakdown}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddVehicleUtilities;
